import Quill from 'quill';
import QuillResizeImage from 'quill-resize-image';

export const quillEditor = () => {
  injectQuillStyles();

  const $quillInputs = document.querySelectorAll('input.js-quill[type="hidden"], textarea.js-quill');
  const instances = [];

  let Size = Quill.import('attributors/style/size');
  Size.whitelist = ['14px', '16px', '18px', '20px', '24px', '26px', '28px', '30px', '32px'];
  Quill.register(Size, true);

  const arrayColors = ['#FFFFFF', '#000000', '#801694', '#f56b0f', '#292994', '#6F7779'];

  Quill.register('modules/resize', QuillResizeImage);

  $quillInputs.forEach(($input, idx) => {
    const editorId = $input.dataset.quillId || `quill-editor-${idx}`;

    let $editor = document.getElementById(editorId);

    if (!$editor) {
      $editor = document.createElement('div');
      $editor.id = editorId;
      $editor.className = 'quill-editor-container';
      $input.parentNode.insertBefore($editor, $input);
    }

    const quill = new Quill($editor, {
      theme: 'snow',
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ color: arrayColors }, { background: arrayColors }],
          [{ size: Size.whitelist }],
          [{ header: [1, 2, 3, false] }],
          [{ align: [] }],
          [{ indent: '-1' }, { indent: '+1' }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link', 'video'],
          ['clean'],
        ],
        resize: {
          locale: {
            center: 'center',
          },
        },
      },
      placeholder: $input.dataset.placeholder || '',
    });

    if ($input.value) {
      quill.clipboard.dangerouslyPasteHTML($input.value);
    }

    quill.on('text-change', () => {
      $input.value = quill.root.innerHTML;
    });

    $input.dataset.quillId = editorId;

    instances.push({
      id: editorId,
      quill,
      input: $input,
      editor: $editor,
    });
  });

  window.quillEditors = instances;
};

const injectQuillStyles = () => {
  // evita inserir o style mais de uma vez
  if (document.getElementById('quill-custom-styles')) return;

  const css = `
  .ql-toolbar.ql-snow {
    background-color: #fff;
  }

  .ql-snow.ql-container {
    height: 400px;
    background-color: #fff;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: attr(data-value) !important;
  }

  .ql-tooltip.ql-editing {
    z-index: 10;
  }

  .ql-align-center { text-align: center; }
  .ql-align-right { text-align: right; }
  .ql-align-justify { text-align: justify; }

  .ql-editor:not(.ql-container .ql-editor):not(.ql-snow .ql-editor) {
    padding: 0;
    border: 0;
    white-space: normal;
    font-size: 14px;
  }

  .ql-snow .ql-tooltip[data-mode="link"]::before {
    content: "Digite a url:";
  }

  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    content: "Salvar";
  }

  .ql-snow .ql-tooltip[data-mode="video"]::before {
    content: "URL do vídeo:";
  }

  .ql-snow .ql-tooltip a.ql-action::after {
    content: "Editar";
  }

  .ql-snow .ql-tooltip a.ql-remove::before {
    content: "Remover";
  }

  .ql-snow .ql-tooltip::before {
    content: "Abrir URL:";
  }
  `;

  const style = document.createElement('style');
  style.id = 'quill-custom-styles';
  style.innerHTML = css;

  document.head.appendChild(style);
};
